const TOKEN_KEY = 'auth_token';

/**
 * Get the authentication token from localStorage
 * @returns {string|null} The token or null if not found
 */
export function getToken() {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch (error) {
    console.error('Error reading token from localStorage:', error);
    return null;
  }
}

/**
 * Set the authentication token in localStorage
 * @param {string} token - The token to store
 */
export function setToken(token) {
  try {
    if (token) {
      localStorage.setItem(TOKEN_KEY, token);
    } else {
      localStorage.removeItem(TOKEN_KEY);
    }
  } catch (error) {
    console.error('Error saving token to localStorage:', error);
  }
}

/**
 * Remove the authentication token from localStorage
 */
export function removeToken() {
  try {
    localStorage.removeItem(TOKEN_KEY);
  } catch (error) {
    console.error('Error removing token from localStorage:', error);
  }
}

/**
 * Check if user has a valid token
 * @returns {boolean} True if token exists
 */
export function hasToken() {
  const token = getToken();
  return token !== null && token !== '';
}

const REFRESH_TOKEN_KEY = 'refresh_token';

export function getRefreshToken() {
  try {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  } catch (error) {
    console.error('Error reading refresh token from localStorage:', error);
    return null;
  }
}

export function setRefreshToken(token) {
  try {
    if (token) {
      localStorage.setItem(REFRESH_TOKEN_KEY, token);
    } else {
      localStorage.removeItem(REFRESH_TOKEN_KEY);
    }
  } catch (error) {
    console.error('Error saving refresh token to localStorage:', error);
  }
}

export function removeRefreshToken() {
  try {
    localStorage.removeItem(REFRESH_TOKEN_KEY);
  } catch (error) {
    console.error('Error removing refresh token from localStorage:', error);
  }
}

export default {
  getToken,
  setToken,
  removeToken,
  hasToken,
  getRefreshToken,
  setRefreshToken,
  removeRefreshToken,
};
